<template>
  <div>
    <table>
      <tr v-for="item in specialList" :key="item.value">
        <td>
          <el-checkbox v-model='item.checked' style="margin: 0 0 0 20px;">{{item.label}}</el-checkbox>
        </td>
        <td v-if="item.checked">
          <el-checkbox v-model='item.isShow' style="margin: 0 0 0 40px;">设为外展用户</el-checkbox>
        </td>
      </tr>
<!--      <tr>-->
<!--        <el-switch v-model="isPass" style="margin: 0 0 0 20px; " active-text="通过简历"></el-switch>-->
<!--      </tr>-->
    </table>
    <div class="dialog-footer" style="margin-bottom: 8px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getFormData, postFormData} from "@/api/api";
import {addUserSpecials, getSpecialsList} from "@/api/url";
export default {
name: "SpecialDialog",
  props: {
    value: Object,
  },
  data() {
    return {
      specialList: [],
      idArray: this.value.idArray,
      sex: this.value.sex,
      loading: false,
      isPass: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    summit() {
      let _this = this;
      this.loading = true;
      let param = {};
      let cArr = [];
      let sArr = [];
      this.specialList.forEach((e) => {
        if(e['checked']) {
          cArr.push(e['value']);
        }
        if(e['isShow']) {
          sArr.push(e['value'])
        }
      });
      param['idArr'] = this.idArray;
      param['specialsIdArr'] = cArr;
      param['specialsIdShowList'] = sArr;
      postFormData(addUserSpecials, param).then(function(data) {
        let {
          code,
          msg
        } = data;
        if(code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          _this.loading = false;
          _this.$emit('confirm')
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
          _this.$emit('close')
        }
      })
          .catch(function(response) {
            _this.loading = false;
          })
    },

    //获取专区列表
    getSpecial() {
      let _this = this
      let param = {};
      param['sex'] = _this.sex;
      getFormData(getSpecialsList, param).then(function(data) {
        let { code, msg } = data;
        if(code == 200) {
          let dataList = data.data;
          dataList.map(item => {
            console.log(1)
            let sexStr = item.sex==1?'男':item.sex==2?'女':'';
            let obj ={}
            obj.label = item.name + '-' + sexStr
            // obj.label = item.name
            obj.value = item.id
            _this.specialList.push(obj)
          })
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }

      })
          .catch(function(response) {})
    },


  },
  mounted() {
    this.getSpecial();
    this.specialList.map(e => {
      e.checked = false
      e.isShow = false
    })
  }
}
</script>

<style scoped>

</style>
